/**
 * English Common Translations
 * 通用翻译模块 - 英语
 * 
 * 包含导航栏 (nav) 和页脚 (footer) 的翻译
 */

import type { CommonTranslations } from '../../types';

export const enCommon: CommonTranslations = {
  nav: {
    home: 'Home',
    products: 'Products',
    technology: 'Technology',
    about: 'About Us',
    contact: 'Contact',
    faq: 'FAQ',
  },
  footer: {
    contact: 'Contact Us',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    rights: 'All rights reserved.',
    brandDesc: 'Professional manufacturer of infrared radiant heaters. Delivering warmth, comfort, and energy efficiency to the world since 2006.',
    products: 'Products',
    support: 'Support',
    newsletter: 'Stay Updated',
    newsletterDesc: 'Subscribe to get latest product updates and industry news.',
    join: 'Join',
    catalog: 'Download Catalog',
    emailPlaceholder: 'Enter your email',
    product1: 'Infrared Heater',
    product2: 'Portable Heater',
    product3: '',
    product4: '',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service',
    sitemap: 'Sitemap',
    installationGuide: 'Installation Guide',
    warrantyPolicy: 'Warranty Policy',
  },
};
